import {Directive, ElementRef, Renderer2, AfterViewInit, forwardRef} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Directive({
  selector: 'input[type=checkbox].hero-form-check',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => HeroInputCheckboxDirective),
      multi: true
    }
  ],
  standalone: true,
})
export class HeroInputCheckboxDirective implements ControlValueAccessor, AfterViewInit {
  private onChange: (value: boolean) => void = () => {
  };
  private onTouched: () => void = () => {
  };

  constructor(
    private el: ElementRef<HTMLInputElement>,
    private renderer: Renderer2
  ) {
    // Event listeners are safe here since they only need the input element
    this.setupEventListeners();
  }

  ngAfterViewInit(): void {
    this.buildDomStructur();
  }

  private buildDomStructur(): void {
    const checkbox = this.el.nativeElement;
    const parent = checkbox.parentElement;
    const nextSibling = checkbox.nextSibling;

    const wrapperDiv = this.renderer.createElement('div');
    this.renderer.addClass(wrapperDiv, 'hero-checkbox-wrapper');

    const checkboxLabel = this.renderer.createElement('label');
    this.renderer.addClass(checkboxLabel, 'hero-checkbox-label');

    const sliderSpan = this.renderer.createElement('span');
    this.renderer.addClass(sliderSpan, 'hero-checkbox-slider');

    this.renderer.appendChild(checkboxLabel, checkbox);
    this.renderer.appendChild(checkboxLabel, sliderSpan);
    this.renderer.appendChild(wrapperDiv, checkboxLabel);

    if (parent) {
      if (nextSibling) {
        this.renderer.insertBefore(parent, wrapperDiv, nextSibling);
      } else {
        this.renderer.appendChild(parent, wrapperDiv);
      }
    } else {
      console.warn('HeroInputCheckboxDirective: No parent element found for wrapping.');
    }
  }

  private setupEventListeners(): void {
    const input = this.el.nativeElement;
    this.renderer.listen(input, 'change', () => {
      const value = input.checked;
      this.onChange(value);
      this.onTouched();
    });
  }

  writeValue(value: boolean): void {
    this.renderer.setProperty(this.el.nativeElement, 'checked', value);
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.renderer.setProperty(this.el.nativeElement, 'disabled', isDisabled);
  }
}
